import { useState } from 'react';
import './App.css';
import HomePage from './modules/list/Homepage';
import Loginpage from './modules/login/Loginpage';

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  return (
    <div className="App">
      {isLoggedIn ? <HomePage handleAutoLogout={setIsLoggedIn} /> : <Loginpage handleLoggedIn={setIsLoggedIn} />}
    </div>
  );
}

export default App;
